/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

// @mui material components
import Card from '@mui/material/Card'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useMaterialUIController } from 'context'
import DashboardLayout from 'modules/LayoutContainers/DashboardLayout'
import LoadingComponent from 'modules/Loading'
import DashboardNavbar from 'modules/Navbars/DashboardNavbar'
import DataTable from 'modules/Tables/DataTable'
import { TabularData } from 'types/server/tabular'

function DataTablesTemplate(): JSX.Element {
	const [controller, _] = useMaterialUIController()
	const { session } = controller
	const fetchData = async () => {
		const response = await axios.get<TabularData>(
			`${process.env.REACT_APP_API_URL}/phone-numbers`,
			{
				headers: {
					Authorization: await session.user.getIdToken(),
				},
			}
		)
		return response.data
	}

	const { data, error, isLoading } = useQuery({ queryKey: ['phone-numbers'], queryFn: fetchData })

	return (
		<DashboardLayout>
			<DashboardNavbar />
			<MDBox pt={6} pb={3}>
				<Card>
					<MDBox p={3} lineHeight={1}>
						<MDTypography variant="h2" fontWeight="medium">
							Phone Numbers
						</MDTypography>
						<MDTypography variant="button" color="text">
							This shows all the phone numbers associated with your account.
						</MDTypography>
					</MDBox>
					{!isLoading && !error ? (
						<DataTable table={data.table} canSearch />
					) : (
						<LoadingComponent type="box" height={600} containerStyle={{ padding: 50 }} />
					)}
				</Card>
			</MDBox>
		</DashboardLayout>
	)
}

export default DataTablesTemplate
